export type SupportedLang = "de" | "en";

export const SUPPORTED_LANGS: readonly SupportedLang[] = ["de", "en"];

export const isSupportedLang = (value: unknown): value is SupportedLang =>
  typeof value === "string" && SUPPORTED_LANGS.includes(value as SupportedLang);
